function consoleLoggerEnabled() {
    return (typeof window !== 'undefined' &&
        'localStorage' in window &&
        !!window.localStorage.getItem('wolt-auth-debug'));
}
export function createLogger(customLogger) {
    return {
        logAction(action, state) {
            if (consoleLoggerEnabled()) {
                console.group(`%c[wolt-auth] %c${new Date().toISOString()}%c ${action}`, 'font-weight: bold; color: purple;', 'font-weight: normal; color: gray;', `font-weight: normal; color: ${/(failure|error)/.test(action) ? 'red' : 'green'};`);
                console.log(state);
                console.groupEnd();
            }
            customLogger?.logAction?.(action, state);
        },
        logMethod(method) {
            if (consoleLoggerEnabled()) {
                console.log(`%c[wolt-auth] %c${new Date().toISOString()}%c ${method}() %ccalled`, 'font-weight: bold; color: purple;', 'font-weight: normal; color: gray;', `font-weight: normal; color: lightblue;`, 'font-weight: normal; color: inherit;');
            }
            customLogger?.logMethod?.(method);
        },
    };
}
